import {ReactElement} from "react";
import {useNavigate} from "react-router-dom";
import {styled} from "styled-components";

import fournisseurElementBG from "@/assets/fournisseurElement.webp";
import IconContrat from "@/assets/iconContrat.svg?react";
import {quicksandSemiBold} from "@/GlobalStyle";

const ElementStyled = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  width: 21rem;
  height: 7.675rem;
  position: relative;
  background-image: url(${fournisseurElementBG});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin: 0 auto;

  &:hover {
    cursor: pointer;
    transform: scale(1.02);
    transition: transform 0.2s ease-in-out;
  }
`;

const LogoStyled = styled.div<{$logo: string}>`
  width: 4.5rem;
  height: 4.5rem;
  background-color: white;
  background-image: url(${({$logo}) => $logo});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 2;
`;

const NomFournisseurStyled = styled.p`
  color: white;
  z-index: 2;
  width: 9.25rem;
  font-size: 1rem;
  ${quicksandSemiBold}
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ContentLogo = styled.div`
  width: 5rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-left: 20px;
`;

const ContratIconContent = styled.div`
  position: absolute;
  right: 2rem;
  background-color: ${({theme}) => theme.colors.mediumSecondary};
  border-radius: 2rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContratIcon = styled(IconContrat)`
  fill: white;
  width: 0.875rem;
`;

export function FournisseurResultat({
  fournisseurName,
  logo,
  hasContrat = false,
  idFournisseur,
}: {
  fournisseurName: string;
  logo: string;
  hasContrat?: boolean;
  idFournisseur: number;
}): ReactElement {
  const navigate = useNavigate();
  return (
    <ElementStyled
      data-testid="ElementStyled"
      onClick={() => navigate(`/fournisseur/${idFournisseur}`)}>
      <ContentLogo>
        <LogoStyled data-testid="LogoStyled" $logo={logo} />
      </ContentLogo>
      <NomFournisseurStyled data-testid="NomFournisseurStyled">
        {fournisseurName}
      </NomFournisseurStyled>
      {hasContrat ? (
        <ContratIconContent data-testid="ContratIconContent">
          <ContratIcon data-testid="ContratIcon" />
        </ContratIconContent>
      ) : null}
    </ElementStyled>
  );
}
